import React, { FC } from 'react'
import { PolaroidList } from 'components/SA/Polaroid'
import ListConnector, { ConnectorProps as ListProps } from '../../connectors/List'
import styles from './BrowsePolaroidList.module.scss'

type BrowsePolaroidListProps = ListProps & {
  isFiltersVisible?: boolean
  isAlgoliaLoading?: boolean
}

const BrowsePolaroidList: FC<BrowsePolaroidListProps> = ({
  algoliaIndice,
  algoliaUserToken,
  artworks,
  isScreenReady,
  isSet,
  userID,
  isFiltersVisible,
  title,
  searchQuery,
  hasPrints,
  isAlgoliaLoading,
}) => {
  if (!artworks.length && !isAlgoliaLoading) {
    return (
      <div className={styles.noResults}>
        <h4 className='defaultTypographyH4 defaultTextCapitalize'>
          Sorry, no results were found for that query.
        </h4>
      </div>
    )
  }

  const dataLayerListName = searchQuery ? `Results for "${searchQuery}"` : title

  const handleCheckIsPrintForDataLayerEvent = ({ hasOpenEditions }) => hasOpenEditions && hasPrints

  return (
    <PolaroidList
      algoliaIndice={algoliaIndice}
      algoliaUserToken={algoliaUserToken}
      dataApi='algolia'
      dataList='plp-results'
      dataListId='plp-results'
      dataListName={dataLayerListName}
      artworks={artworks}
      isLoading={!isScreenReady || !isSet || isAlgoliaLoading}
      userID={userID}
      customStyle={!isFiltersVisible ? styles.customPolaroidListContainer : ''}
      showPrintsFromInPrice={hasPrints}
      isPrintsFromVisible={false}
      isMediumMaterialVisible={!hasPrints}
      isDimensionsVisible={!hasPrints}
      showOriginalPrice={hasPrints}
      hasPrints={hasPrints}
      onCheckIsPrintForDataLayerEvent={handleCheckIsPrintForDataLayerEvent}
      skeletonQuantity={100}
    />
  )
}

export default ListConnector(BrowsePolaroidList)
